import {environment} from '@/environments/environment';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Article, ArticleTiny, ArticleWithNavigation} from '@/app/core/models/article';
import {Page} from '@/app/core/models/page';

@Injectable({
	providedIn: 'root'
})
export class ArticleService {

	constructor(
		private readonly http: HttpClient
	) {}

	getThreeRecentArticles(): Observable<ArticleTiny[]> {
		return this.http.get<ArticleTiny[]>(`${environment.backendUrl}/article/recent`);
	}

	getArticles(page: number, filter: string[]): Observable<Page<ArticleTiny>> {
		return this.http.get<Page<ArticleTiny>>(`${environment.backendUrl}/article?page=${page}&filter=${filter}`);
	}

	getArticle(articleId: string): Observable<ArticleWithNavigation> {
		return this.http.get<ArticleWithNavigation>(`${environment.backendUrl}/article/${articleId}`);
	}
}
